import React from 'react';

type IconProps = {
  className?: string;
};

const baseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const;

export const StatusIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <circle cx="12" cy="12" r="8" />
    <circle cx="12" cy="12" r="2.5" />
  </svg>
);

export const NotesIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <path d="M7 3h8l4 4v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" />
    <path d="M15 3v4h4" />
    <path d="M8 12h8" />
    <path d="M8 16h5" />
  </svg>
);

export const IntelligentSearchIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <circle cx="10" cy="10" r="4" />
    <path d="M14 14l4 4" />
    <path d="M18 5v2.5" />
    <path d="M16.75 6.25h2.5" />
    <path d="M16.9 4.9l2.2 2.2" />
    <path d="M19.1 4.9l-2.2 2.2" />
  </svg>
);

export const ResumeAssignmentIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <rect x="5" y="3" width="12" height="16" rx="2" />
    <path d="M8 7h6" />
    <path d="M8 11h6" />
    <circle cx="18" cy="18" r="3" />
    <path d="M17 18l1 1 2-2" />
  </svg>
);

export const InterviewPrepIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <rect x="6" y="5" width="12" height="15" rx="2" />
    <rect x="9" y="3" width="6" height="3" rx="1" />
    <path d="M9 11l1.5 1.5L14 9" />
    <path d="M9 15h6" />
  </svg>
);

export const GuidedPrepSummaryIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <rect x="5" y="4" width="11" height="16" rx="2" />
    <path d="M8 8h5" />
    <path d="M8 12h5" />
    <path d="M18.5 8.5l.8 1.6 1.7.2-1.2 1.2.3 1.7-1.6-.8-1.6.8.3-1.7-1.2-1.2 1.7-.2.8-1.6z" />
  </svg>
);

export const CommunicationCoachIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <path d="M5 7a3 3 0 0 1 3-3h7a3 3 0 0 1 3 3v3a3 3 0 0 1-3 3H9l-3 3v-3H8a3 3 0 0 1-3-3V7z" />
    <path d="M14 14h3a2.5 2.5 0 0 1 2.5 2.5v1.5l-2-1.5h-3a2.5 2.5 0 0 1-2.5-2.5V14z" />
  </svg>
);

export const CompanyIntelIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <rect x="4" y="4" width="10" height="16" rx="2" />
    <path d="M7 8h1" />
    <path d="M10 8h1" />
    <path d="M7 12h1" />
    <path d="M10 12h1" />
    <circle cx="18" cy="16" r="3" />
    <path d="M20.5 18.5l2 2" />
  </svg>
);

export const EditIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <path d="M4 20l4-1 9-9-3-3-9 9-1 4z" />
    <path d="M13 5l3 3" />
  </svg>
);

export const DeleteIcon: React.FC<IconProps> = ({ className }) => (
  <svg {...baseProps} className={className} aria-hidden="true" focusable="false">
    <path d="M6 7h12" />
    <path d="M9 7V5h6v2" />
    <rect x="7" y="7" width="10" height="12" rx="2" />
    <path d="M10 11v6" />
    <path d="M14 11v6" />
  </svg>
);
